import React, { useState } from "react";
import ListPagination from "./ListPagination";
import PageLayout from "../Layout/PageLayout";
import Loader from "../../Assets/Images/loader.gif";

function ListingPage(props) {
  
  const handleSelectChange = (filterName, value) => {
    props.setLoadingStatus((prevParams) => ({ ...prevParams, table: true }));
    props.setListParams((prevParams) => ({
      ...prevParams,
      [filterName]: value,
    }));
    if (filterName === "search_term" || "tab")
      props.setListParams((prevParams) => ({ ...prevParams, offset: 0 }));
  };

  const handlePageClick = (event) => {
    props.setLoadingStatus((prevParams) => ({ ...prevParams, table: true }));
    props.setListParams((prevParams) => ({
      ...prevParams,
      page: event.selected + 1,
    }));
  };

  return (
    <>
      <PageLayout
        title={props.title}
        button={props.button}
        atag={props.atag}
        title2={props.title2}
        title2cls={props.title2cls}
        listing={true}
      >

       {props.search && <div className="row">
          <div className="col-sm-6 col-lg-6 mx-auto text-lg-end text-center mb-1">
            <div className="d-flex">
                {props.filters &&
                    <div className="sort-sec my-0"  >
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onChange={(e) =>
                          handleSelectChange('filter_by',e.target.value)
                        }
                      >
                        {props.filters?.map((option,i) => (
                          <option
                            value={option.value}
                            key={i}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  }
                  {props?.filter2 &&  props.listParams.status != 'draft' &&
                    <div className={`sort-sec my-0 ${props.addclass || ''}`}> 
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onChange={(e) =>
                          handleSelectChange('type',e.target.value)
                        }
                      >
                        {props.filter2?.map((option,i) => (
                          <option
                            value={option.value}
                            key={i}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  }
              </div>
          </div>
        <div className="col-sm-6 col-lg-6 mx-auto text-lg-end text-center mb-1">
          <ul className="top-search">
            <li className="d-block">
              <form className=" form-inline  ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                <div className="input-group pe-1">
                  <div className="input-group-append">
                    <button className="btn" type="button">
                      <i className="fas fa-search fa-sm"></i>
                    </button>
                  </div>
                  <input
                    type="text"
                    className="form-control border-0 small"
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={props.listParams.search_term}
                    onChange={(e) => handleSelectChange('search_term',e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  />
                  <div className="input-group-append">
                    {props.listParams.search_term && 
                      <button className="btn btn-remove" type="button" onClick={() => handleSelectChange('search_term','')}>
                      <i className="fas fa-close fa-sm"></i>
                    </button> }
                  </div>
                </div>
              </form>
            </li>
          
          </ul>
        </div>
        </div>}
        <div className="row">
          <div className="col-12">
            {props.loadingStatus.page ? (
              // <Loader />
              <p/>
            ) : (
              <>
                {/* tabs and filter start */}
              {props.tabs && props.filters && <div className="row d-flex align-items-center justify-content-center flex-wrap ">
                <div className="col-xl-5 mb-3">
                  <div className="d-flex justify-content-center justify-content-xl-start">
                    <ul className="sort-btn-group">
                      {props.tabs?.map((option, optionIndex) => (
                          <li key={optionIndex}>
                            <a className={`btn tabview ${option.value === props.listParams[props.tabKey||'type'] ? "active" : "" }`}
                              onClick={() =>handleSelectChange(option.key, option.value)}
                              title={option.label}
                            >
                              {option.icon && <img src={option.icon} />}
                              {option.label} {option.userCount !== undefined && <span className="count">{option.userCount}</span> } 
                            </a>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                <div className="col-xl-7 mb-3">
                  <div className="d-flex align-content-center justify-content-center justify-content-xl-end flex-wrap">
                    {props.limitSort?.map((filter, index) => (
                      <>
                      <div className="sort-sec my-2 me-2" key={index}>
                        <p className="me-1">Show </p>
                        <select
                          className="form-select w-100"
                          aria-label="Default select example"
                          value={props.listParams['limit']}
                          onChange={(e) =>
                            handleSelectChange('limit', e.target.value)
                          }
                        >
                          {filter.options?.map((option,i) => (
                            <option
                              value={option.value}
                              key={i}
                            >
                              {option.option}
                            </option>
                          ))}
                        </select>
                        <p className="me-3">entries </p>
                      </div>
                      </>
                    ))}
                    
                    {props.createBtn}
                  </div>
                </div>
              </div>}
                {props.children}

                <ListPagination
                  pageChange={handlePageClick}
                  totalCount={props.totalCount}
                  perpage={props.listParams["limit"]}
                  currentPage={props.listParams.page - 1}
                />
                {/* </div> */}
              </>
            )}
          </div>
        </div>
      </PageLayout>
    </>
  );
}

export default ListingPage;
